module.exports = __webpack_public_path__ + "6c4a0dbc/img/send-icon.3cfb6275.svg";